import { CustomStepDefinition, LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DateLastVerifiedBucketEnum } from 'src/portal/search-api/models/date-last-verified-bucket-enum';

@Component({
  selector: 'search-filter-slider-last-verified',
  templateUrl: './search-filter-slider-last-verified.component.html',
  styleUrls: ['./search-filter-slider-last-verified.component.scss']
})
export class SearchFilterSliderLastVerifiedComponent implements OnChanges {

  @Input() selectedLastVerified: DateLastVerifiedBucketEnum | undefined;
  @Input() disabled: boolean = false;
  @Output() onChangeValue = new EventEmitter<DateLastVerifiedBucketEnum[]>();

  private readonly lastVerifiedSteps: Array<{ value: DateLastVerifiedBucketEnum | undefined; label: string }> = [
    { value: undefined, label: 'Any' },
    // { value: DateLastVerifiedBucketEnum.ANCIENT, label: '10 Years' },
    { value: DateLastVerifiedBucketEnum.OLD, label: 'Last 5 Years' },
    { value: DateLastVerifiedBucketEnum.NEW, label: 'Last Year' },
    { value: DateLastVerifiedBucketEnum.RECENT, label: 'Recent' },
  ];
  // Ordered from most recent to least recent to build inclusive selections.
  private readonly cascadingOrder: DateLastVerifiedBucketEnum[] = [
    DateLastVerifiedBucketEnum.RECENT,
    DateLastVerifiedBucketEnum.NEW,
    DateLastVerifiedBucketEnum.OLD,
  ];

  sliderValue: number = 0;
  sliderOptions: Options = this.buildSliderOptions(this.disabled);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      this.sliderOptions = this.buildSliderOptions(this.disabled);
    }
    if (changes.selectedLastVerified) {
      this.sliderValue = this.lastVerifiedToIndex(this.selectedLastVerified);
    }
  }

  private lastVerifiedToIndex(lastVerified: DateLastVerifiedBucketEnum | undefined): number {
    const index = this.lastVerifiedSteps.findIndex((step) => step.value === lastVerified);
    return index >= 0 ? index : 0;
  }

  public onLastVerifiedChange(): void {
    const step = this.lastVerifiedSteps[this.sliderValue];
    this.onChangeValue.emit(this.buildCascadeSelection(step?.value));
  }

  private buildSliderOptions(disabled: boolean): Options {
    return {
      floor: 0,
      ceil: this.lastVerifiedSteps.length - 1,
      showTicks: true,
      showTicksValues: true,
      animate: true,
      rightToLeft: true,
      disabled,
      stepsArray: this.lastVerifiedSteps.map((_, index): CustomStepDefinition => ({ value: index })),
      translate: (value: number, label: LabelType): string => {
        const step = this.lastVerifiedSteps[value];
        return step?.label ?? '';
      },
    };
  }

  private buildCascadeSelection(selectedValue: DateLastVerifiedBucketEnum | undefined): DateLastVerifiedBucketEnum[] {
    if (!selectedValue) {
      return [];
    }

    const index = this.cascadingOrder.indexOf(selectedValue);
    if (index === -1) {
      return [];
    }

    return this.cascadingOrder.slice(0, index + 1);
  }
}
